export type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };

// Parses a JSON string that is expected to describe an object. Returns null for
// malformed JSON and for valid-but-non-object JSON (arrays, primitives, null),
// so callers can treat "unusable" as a single case.
//
// The values are typed JsonValue rather than unknown: everything JSON.parse can
// produce is by construction a JSON value, so the assertion is sound.
export function tryParseJson(input: string): Record<string, JsonValue> | null {
  try {
    const parsed = JSON.parse(input);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? (parsed as Record<string, JsonValue>)
      : null;
  } catch {
    return null;
  }
}
